import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/Button';
import { Input } from '../../components/Input';
import { Label } from '../../components/Label';
import Logo from '../../assets/logo.svg';
import './styles.css';
import api from '../../services/api';
import useAuth from '../../hooks/useAuth';
import { toast } from 'sonner';
import { AxiosError } from 'axios';

export const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>('');
  const navigate = useNavigate();
  const { handleAddToken } = useAuth();

  interface AuthResponse {
    access: string;
    refresh: string;
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (!username || !password) {
        setError('Usuário e senha são obrigatórios');
        toast.error('Usuário e senha são obrigatórios');
        return;
      }

      const response = await api.post<AuthResponse>('/api/v1/authentication/token/', {
        username,
        password
      });

      const { access } = response.data;
      handleAddToken(access);

      navigate('/main');
    } catch (error) {
      console.error('Erro ao fazer login:', error);
      const axiosError = error as AxiosError;
      
      // Mensagem genérica por segurança - não revela se usuário existe ou não
      const genericErrorMessage = 'Credenciais inválidas ou erro ao processar a requisição';
      
      // Verifica se é erro de autenticação ou validação
      if (axiosError.response?.status === 401 || axiosError.response?.status === 400) {
        setError(genericErrorMessage);
        toast.error(genericErrorMessage);
      } else if (!axiosError.response) {
        // Erro de rede - mensagem genérica também
        setError('Erro ao conectar com o servidor. Tente novamente.');
        toast.error('Erro ao conectar com o servidor. Tente novamente.');
      } else {
        // Qualquer outro erro - mensagem genérica
        setError(genericErrorMessage);
        toast.error(genericErrorMessage);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <img src={Logo} alt="Logo" />
          <p className="login-subtitle">
            Bags Exclusivas
          </p>
        </div>

        <div className="login-card">
          <h2 className="login-card-title">
            Sistema de Ordens de Serviço
          </h2>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="login-field">
              <Label htmlFor="username" className="login-label">
                Usuário
              </Label>
              <Input
                id="username"
                data-testid="login-username-input"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Digite seu usuário"
                className="login-input"
                required
              />
            </div>

            <div className="login-field">
              <Label htmlFor="password" className="login-label">
                Senha
              </Label>
              <Input
                id="password"
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Digite sua senha"
                className="login-input"
                required
              />
            </div>

            {error && (
              <div className="login-error">
                {error}
              </div>
            )}
            <Button
              type="submit"
              data-testid="login-submit-button"
              disabled={loading}
              className="login-button"
            >
              {loading ? 'Entrando...' : 'Entrar'}
            </Button>
          </form>
        </div>

        <p className="login-footer">
          Sistema de gerenciamento de ordens de serviço
        </p>
      </div>
    </div>
  );
};

